<template>
  <a-form-item :label="data.fieldname">
    <a-rate
      v-if="data"
      v-decorator="[`${data.fieldkey}`, {
        validateTrigger: ['change', 'blur'],
        rules: [{ required: data.isneeded === 1 ? true : false, message: placeholder }],
        initialValue: defaultVal
      }]"
      :count="data.fieldconfig && data.fieldconfig.level"
      @change="onChange"
    >
      <i
        slot="character"
        class="iconfont iconicon-test6"
      />
    </a-rate>
    <a-tooltip
      v-if="isexplain"
      placement="right"
      overlay-class-name="radio-tooltip"
    >
      <template slot="title">
        <template v-for="(item, i) in explain">
          <p
            v-if="item.name"
            :key="i"
          >
            {{ item.key }}: {{ item.name }}
          </p>
        </template>
      </template>
      <i
        v-if="isexplain"
        class="iconfont iconicon-test34 fs-gray explain-btn"
      />
    </a-tooltip>
  </a-form-item>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  data () {
    return {
      defaultVal: 0
    }
  },
  computed: {
    isexplain () {
      const { fieldconfig = {} } = this.data || {}
      const { isexplain } = fieldconfig
      return isexplain
    },
    explain () {
      const { fieldconfig = {} } = this.data || {}
      const { explain = [], type } = fieldconfig
      let arr = []
      const starArr = this.$t('message["1386"]').split(',')
      let newExplain = []
      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        arr = starArr
      }
      explain.forEach((item, index) => {
        let obj = {}
        arr.forEach((code, i) => {
          if (index === i) {
            if (type === 1) {
              obj.key = code
            } else {
              obj.key = explain.length - i + code
            }
            obj.name = item
            newExplain.push(obj)
          }
        })
      })
      return newExplain
    }
  },
  watch: {
    value (val) {
      this.defaultVal = this.value || 0
    },
    data: {
      handler (val) {
        if (this.value) {
          this.defaultVal = this.value || 0
        } else {
          this.defaultVal = val.fieldvalue || 0
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onChange (value) {
      if (!this.data) return

      this.defaultVal = value
      this.data.fieldvalue = value
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.explain-btn {
  margin-left: 12px;
  vertical-align: bottom;
  cursor: pointer;
}
</style>
